import {
  computedFieldSummaryPayloadSchema,
  computedFieldSummaryResponseSchema,
} from './computedFieldSummary.schema';
import { FormulaSummaryPayload } from './schemas/formulaSummary';

export type SummaryBlock = {
  keyword: string;
  summary: string;
};

export type QuerySummary = {
  title: string;
  subtitle: string;
  blocks: SummaryBlock[];
};

export type ComputedFieldSummaryResponse = {
  results: {
    summary: QuerySummary[];
  }[];
};

export type ComputedFieldSummaryPayload = FormulaSummaryPayload;

export const computedFieldSummary = (payload: ComputedFieldSummaryPayload) => {
  return {
    endpoint: `internal/schemas/computed_field_summary`,
    method: 'POST',
    responseSchema: computedFieldSummaryResponseSchema,
    payload,
    payloadSchema: computedFieldSummaryPayloadSchema,
  } as const;
};
